import {
  params,
  alias,
  string as stringType,
  shape as shapeType,
  arrayOf as arrayOfType
} from '@thd-nucleus/data-sources';

export const cppDataModel = {
  getDesignIdsBySearchTerm: params({
    searchTerm: stringType(),
    searchType: stringType(),
    productLine: stringType()
  }).shape(stringType()),
  clientOnlyProduct: alias('product').params({
    itemId: stringType().isRequired()
  }).shape({
    dataSources: stringType(),
    taxonomy: shapeType({
      breadCrumbs: arrayOfType(shapeType({
        label: stringType()
      }))
    })
  })
};